// @flow

import { type Card } from './types';

export function getExpiryDate(card: Card): string {
  return card.expiryDate;
}
